'use client';

import { useContext } from 'react';

import { WebUiGlobalContext } from './global-context';

// ----------------------------------------------------------------------

export const useWebUiGlobalContext = () => {
  const context = useContext(WebUiGlobalContext);

  if (!context)
    throw new Error(
      'useWebUiGlobalContext context must be use inside WebUiGlobalProvider',
    );

  return context;
};
